import React from 'react'

import Page from '../../components/Page'

const Error: React.FC<React.PropsWithChildren<unknown>> = () => <Page title="Error">ERROR!</Page>

export default Error
